import CacheStore from 'bz-utilities/modules/stores/cached-map-store';
import { computed } from 'mobx';
import type { LocationResponse } from 'tm3-core/api.dtos';

class CustomerLocationsStore extends CacheStore<LocationResponse> {
  constructor() {
    super('customerLocations');
  }
  @computed get CurrentLocations() {
    return this.All.filter((x) => x.status === '0'); // not sure why this is a string
  }
}

export default CustomerLocationsStore;
